import {FBFieldBaseOptions} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {
    ConditionTypeEnum,
    ShowHideConditionOptions,
    ValidationConditionOptions
} from "FormBuilder/Fields/Core/ConditionOptions";
import {ShowHideConditionProcessor} from "FormBuilder/Core/Conditions/ShowHideConditionProcessor";
import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {RetrieverSource, ValueRetrieverBase} from "FormBuilder/Core/ValueRetriever/Core/ValueRetrieverBase";
import {ValueRetrieverFactory} from "FormBuilder/Core/ValueRetriever/Core/ValueRetrieverFactory";
import {ErrorItem} from "FormBuilder/Fields/Core/Utilities/ErrorItem";
import {ConditionProcessorBase} from "FormBuilder/Core/Conditions/ConditionProcessorBase";
import {SingleEvent} from "shared/core/Events/SingleEvent";
import {FormulaManager} from "FormBuilder/Fields/Core/FormulaManager";
import {ValidationConditionProcessor} from "FormBuilder/Core/Conditions/ValidationConditionProcessor";
import {ScrollingUtil} from "FormBuilder/Utilities/ScrollingUtil";

export abstract class FBFieldBaseModel<Op extends FBFieldBaseOptions=FBFieldBaseOptions,P extends FBColumnModel=FBColumnModel> extends ModelWithParent<Op,P> implements RetrieverSource{

    Conditions: ConditionProcessorBase[];
    public ValueChanged:SingleEvent;
    public ValueRetriever:ValueRetrieverBase;
    public Errors:ErrorItem[];
    public ImmediateAnimation:boolean;
    public IsVisible:boolean=true;
    public IsFocused:boolean;
    public FormulaManager:FormulaManager;
    public Instance:HTMLDivElement;

    constructor(Options: Op, Parent: P) {
        super(Options, Parent);
        this.ImmediateAnimation=true;
        this.Errors=[];
        this.ValueChanged=new SingleEvent();
        this.Conditions=[];
        this.IsFocused=false;
        this.FormulaManager=new FormulaManager(this);


    }

    public Initialize(previousData:any=null):this{
        this.ValueRetriever=ValueRetrieverFactory.GetValueRetriever(this);
        this.InitializeStartingValues(previousData);

        return this;
    }

    protected abstract InitializeStartingValues(previousData?:any);

    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

    public GetPreviousDataProperty(propertyName:string,defaultValue:any)
    {
        let previousData=this.GetPreviousData();
        if(previousData==null||previousData[propertyName]==null)
            return defaultValue;

        return previousData[propertyName];
    }

    public GetPreviousData(){
        if(this.FormBuilder==null)
            return null;
        let previousData=this.FormBuilder.PreviousData;
        if(previousData==null||previousData.Fields==null)
            return null;
        return previousData.Fields.find(x=>x.Id==this.Options.Id);
    }

    public  GetValue():any{
        return null;
    }

    public GetPrice(){
        return 0;
    }

    public get FormBuilder():ContainerDataRetriever{
        if(this.Parent==null)
            return null;
        return this.Parent.Parent.Parent;
    }


    public GetDynamicFieldNames():string[]{
        return [this.Options.Type];
    }

    public RemoveError(id: string) {
        let errorToRemove=this.Errors.find(x=>x.Id==id);
        if(errorToRemove==null)
            return;

        this.Errors.splice(this.Errors.indexOf(errorToRemove),1);
        this.Refresh();
    }

    public GetIsUsed(){
        return this.GetIsVisible();
    }

    FireValueChanged(){
        if(this.GetIsUsed())
            this.RemoveError('required');
        this.FormBuilder.FieldValueChanged.Publish(this);
        this.ValueChanged.Publish(this);
        this.Refresh();
    }



    public AddError(id:string,message:string)
    {
        if(this.Errors.some(x=>x.Id==id))
            return;
        else {
            this.Errors.push(new ErrorItem(id, message));
            this.Refresh();
        }
    }

    public SerializeEntry(){
        let obj={
            Label:this.Options.Label,
            Id:this.Options.Id,
            Type:this.Options.Type
        };
        this.InternalSerialize(obj);
        return obj;
    }



    public InitializeConditions(){
        this.InitializeFormulas();
        for(let condition of this.Options.Conditions)
        {
            switch (condition.Type) {
                case ConditionTypeEnum.ShowHide:
                    this.Conditions.push(new ShowHideConditionProcessor().InitializeWidthFields(this,condition as ShowHideConditionOptions));
                    break;
                case ConditionTypeEnum.Validation:
                    this.Conditions.push(new ValidationConditionProcessor().InitializeWidthFields(this,condition as ValidationConditionOptions));
                    break;
            }
        }
    }


    public Hide(immediate:boolean=false){
        if(this.IsVisible==true)
        {
            this.ImmediateAnimation=immediate;
            this.IsVisible=false;
            this.FireValueChanged();
            this.Refresh();
        }
    }

    public GetIsVisible(){
        return this.IsVisible;
    }

    public Focus(){
        this.IsFocused=true;
        this.Refresh();
    }

    public UnFocus(){
        this.IsFocused=false;
        this.Refresh();
    }


    public Show(immediate:boolean=false){
        if(this.IsVisible==false)
        {
            this.ImmediateAnimation=immediate;
            this.IsVisible=true;
            this.FireValueChanged();
            this.Refresh();
        }
    }



    public GetIsValid(){
        return this.Errors.length==0;
    }

    public Validate(){
        if((this.GetIsVisible()&&this.Options.Required)&&!this.GetIsUsed())
        {
            this.AddError('required','Required');
        }else
            this.RemoveError('required');

        this.Conditions.filter(x=>x.Options.Type==ConditionTypeEnum.Validation).forEach(x=>x.ExecuteCondition());

        return this.GetIsValid();
    }

    public GetText(){
        return '';
    }



    public abstract GetStoresInformation():boolean;
    protected abstract InternalSerialize(obj:object);

    private InitializeFormulas() {
        if(this.Parent!=null&&!this.Parent.IsDesign)
            this.FormulaManager.StartListener();

    }

    public ScrollToField(){
        if(this.Instance==null)
            return;
        let position=this.Instance.getBoundingClientRect();

        if(position.top<0)
        {
            ScrollingUtil.ScrollTo(document.documentElement,document.documentElement.scrollTop+position.top-50)
        }
    }
}